module.exports = __webpack_public_path__ + "img/[愉快].eca98fac.svg";